import { Box, Popover } from '@mui/material';
import { Typography } from 'gd-design-library';
import React, { useCallback, useContext } from 'react';
import { ChatbotWidgetContext } from '../../utils/ChatbotWidgetContext';
import Logo from '@assets/images/griddynamics-logo-min.svg';
import { View } from '../../constants/view';
import styles from './WidgetPopover.module.scss';
import classNames from 'classnames/bind';
import { SelectContactOption } from 'components/ChatbotWidget/views/SelectContactOption';
import { ChatSignIn } from 'components/ChatbotWidget/views/ChatSignIn';
import { CallSignIn } from 'components/ChatbotWidget/views/CallSignIn';
import { Chat } from 'components/ChatbotWidget/views/Chat';
import { Rating } from 'components/ChatbotWidget/views/Rating';
import { RatingSubmitted } from 'components/ChatbotWidget/views/RatingSubmitted';
import { CallSubmitted } from 'components/ChatbotWidget/views/CallSubmitted';

const cx = classNames.bind(styles);

const CN = 'widget-popover';
const paperClassName = `${CN}__paper`;
const viewContainerClassName = `${CN}__view-container`;
const footerClassName = `${CN}__footer`;
const footerLogoClassName = `${CN}__footer-logo`;

const WIDGET_HEIGHT = 700;
const WIDGET_MARGIN = 16;

interface ChatPopoverProps {
  anchorEl: null | HTMLElement;
  close: () => void;
}

export const WidgetPopover = ({
  anchorEl,
  close
}: ChatPopoverProps): React.ReactElement => {
  const { view } = useContext(ChatbotWidgetContext);

  const renderView = useCallback(() => {
    switch (view) {
    case View.SELECT_CONTACT_OPTION:
      return <SelectContactOption />;
    case View.CHAT_SIGN_IN:
      return <ChatSignIn />;
    case View.CALL_SIGN_IN:
      return <CallSignIn />;
    case View.CHAT:
      return <Chat />;
    case View.RATING:
      return <Rating />;
    case View.RATING_SUBMITTED:
      return <RatingSubmitted />;
    case View.CALL_SUBMITTED:
      return <CallSubmitted />;
    default:
      return null;
    }
  }, [ view ]);

  return (
    <Popover
      open={ Boolean(anchorEl) }
      anchorEl={ anchorEl }
      keepMounted
      onClose={ close }
      transformOrigin={ {
        vertical: WIDGET_HEIGHT + WIDGET_MARGIN,
        horizontal: 0
      } }
      className={ cx(CN) }
      slotProps={ { paper: { className: cx(paperClassName) } } }
    >
      <Box className={ cx(viewContainerClassName) }>
        {renderView()}
      </Box>
      <Typography
        align='center'
        variant='caption'
        color='GrayText'
        className={ cx(footerClassName) }
      >
        Built by Grid Dynamics
        <img
          src={ Logo.src }
          alt='Grid Dynamics Logo'
          className={ cx(footerLogoClassName) }
        />
      </Typography>
    </Popover>
  );
};
